module.exports = __webpack_public_path__ + "img/Linkedin.4d4455e2.svg";